import { FormControl, TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import * as React from "react";
import * as uuid from "uuid";
import { getGlobalVar, Helpers } from "../../utils/helpers";

const GAME_ITEMS = getGlobalVar("ITEMS").map(item => {
    const name = Helpers.getLocalizationName(item.name);

    return {
        ...item,
        name,
        firstLetter: item.type.replace("_", " ").toUpperCase(),
    };
});

interface ItemListProps {
    label: string;
    value: any;

    onChange(e, value: any);
}

interface ItemListState {
    id: string;
}

export class ItemSelect extends React.Component<ItemListProps, ItemListState> {
    state = {
        id: uuid.v4()
    };

    handleChange = (e, newItem) => {
        this.props.onChange(e, newItem.id);
    };

    getOptionLabel = (option) => {
        if (typeof option === "number" || typeof option === "string") {
            const item = GAME_ITEMS.find(_item => _item.id === option);

            return item?.name || "Missing";
        }

        return option.name;
    };

    render() {
        return <FormControl style={{
            marginRight: 8,
            width: "100%",
            marginBottom: 10,
        }}>
            <Autocomplete
                onChange={this.handleChange}
                value={this.props.value}
                options={GAME_ITEMS.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                groupBy={option => option.firstLetter}
                getOptionLabel={this.getOptionLabel}
                isOptionEqualToValue={(option, value) => option.id === value}
                renderInput={(params) =>
                    <TextField {...params} label={this.props.label} id={`item_select_${this.state.id}`}/>}
            />
        </FormControl>;
    }
}
